import { useAppSelector } from "../../store/hooks";
import { DateTime } from "luxon";
import { UserHealth } from "../../types/model";
import AppConnectedUI from "../ui/AppConnectedUI";

interface AppConnectedProps {
    userHealth?: UserHealth;
}

export default function AppConnected(props: AppConnectedProps) {
    const locale = useAppSelector(state => state.locale.language);

	if (!props.userHealth || props.userHealth.last_app_activity === undefined) {
        return <AppConnectedUI type="not_connected" />
	}

    const lastConnected = DateTime.fromISO(props.userHealth.last_app_activity);

    let relativeTime = lastConnected.toRelative({ locale });
    
    // For platforms too old to support Intl.RelativeTimeFormat.
    // We don't support those platforms, so this should be sufficient.
    if (relativeTime === null) relativeTime = props.userHealth.last_app_activity;

    if (lastConnected.diffNow().toMillis() < -48 * 60 * 60 * 1000) {
        // Last connection more then two days ago, show maybe connected.
        return <AppConnectedUI type="maybe_connected" relativeTime={relativeTime} />;
    } else {
        // Last connection less then two days ago, show connected.
        return <AppConnectedUI type="connected" relativeTime={relativeTime} />;
    }
}
